const CONTRACT_SERIES = [
  'Д-К-',
  'Д-ФЛ-',
  'И01-',
  'И02-',
  'КСОЗ-',
  'НСЖ-',
  'ЮЗ-',
  'ЮЗДИ-',
  'ЮЗМ-',
  'ЮЗРК-',
  'ЮЗРКПО-',
  'ЮЗС-',
  'ЮЗТ-',
  'ЮЗЮИ-',
  'ЮВКС-',
  'ЮИ-',
  'ЮИ1-',
  'ЮИ1.5-',
  'ЮИ2-',
  'ЮИ3-',
  'ЮИ5-',
  'ЮИ7-',
  'ЮИ06-',
  'ЮИКМ-',
  'ЮН-',
  'ЮНВП-',
  'ЮНВПР-',
  'ЮНД-',
  'ЮНДС1-',
  'ЮНДС2-',
  'ЮНДС3-',
  'ЮНЗ-',
  'ЮНЗД-',
  'ЮНЗО-',
  'ЮНЗС-',
  'ЮНН-',
  'ЮНПЗЛ-',
  'ЮНПЗС-',
  'ЮНПЗД-',
  'ЮНВПЕД-',
  'ЮНВПЮ-',
  'ЮНПР-',
  'ЮНСБ1-',
  'ЮНСБ2-',
  'ЮНСБ3-',
  'ЮНСБ4-',
  'ЮНСК-',
  '01-',
  '02-',
  '06-',
  '07-',
  '01/',
  '02/',
  '04/',
  '06/'
];

export { CONTRACT_SERIES };
